import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class StakeService {
  private selectedStake: string | undefined;
  private activeCrossSell: boolean = false;
  private $subscriber: BehaviorSubject<any>;

  constructor () {
    this.$subscriber = new BehaviorSubject(this.selectedStake);
  }

  getStake() {
    return this.$subscriber;
  }

  setStake(stake: string, isCrossSell: boolean = false): void {
    this.activeCrossSell = isCrossSell || false;
    this.selectedStake = stake;
    this.$subscriber.next(this.selectedStake);
  }

  clearStake(): void {
    if (!this.activeCrossSell) {
      this.selectedStake = undefined;
      this.$subscriber.next(this.selectedStake);
    }
  }
}
//
//
// import { Injectable, signal, Signal } from '@angular/core';
//
// @Injectable({
//   providedIn: 'root'
// })
// export class StakeService {
//   private _selectedStake = signal<string | undefined>(undefined);
//   private activeCrossSell = false;
//
//   // Expose as a read-only signal to prevent external mutation
//   readonly selectedStake: Signal<string | undefined> = this._selectedStake.asReadonly();
//
//   getStake(): Signal<string | undefined> {
//     return this.selectedStake;
//   }
//
//   setStake(stake: string, isCrossSell: boolean = false): void {
//     this.activeCrossSell = isCrossSell || false;
//     this._selectedStake.set(stake);
//   }
//
//   clearStake(): void {
//     if (!this.activeCrossSell) {
//       this._selectedStake.set(undefined);
//     }
//   }
// }
